export default {
  RPI_CLIENT_LIST (state, value) {
    state.list = value || []
  },
  RPI_CLIENT_LATEST_CLIENT_VERSION (state, value) {
    state.latestClientVersion = value || null
  },
  RPI_CLIENT_SWUPDATE_URL (state, value) {
    state.swupdateUrl = value || null
  }
}
